import { useState } from "react";

import baseLogo from "../assets/img/logo.svg";

import globalStyles from "../assets/styles/bootstrap.min.module.css";

import LoginForm from "../components/LoginForm";

import classes from "./LoginPage.module.css";

export type LoginPageProps = {};

const LoginPage = (props: LoginPageProps) => {
  //state for whether isLogin or signup
  const [isLogin, setIsLogin] = useState<boolean>(true);
  const toggleLoginSignup = () => {
    setIsLogin((isLogin) => !isLogin);
  };
  return (
    <div className={`${globalStyles.container} ${classes.login_container}`}>
      <div className={globalStyles.row}>
        <div
          className={`${globalStyles["col-md-8"]} ${globalStyles["my-auto"]} ${globalStyles["text-center"]}`}
        >
          <img src={baseLogo} alt="base logo"></img>
        </div>
        <div className={globalStyles["col-md-4"]}>
          <div className={`${globalStyles.card} ${classes.loginbox}`}>
            <div className={globalStyles["card-header"]}>
              <div className="tabbable-responsive">
                <div className="tabbable">
                  <ul
                    className={`${globalStyles.nav} ${globalStyles["nav-tabs"]} ${classes["nav-tabs"]}`}
                  >
                    <li
                      className={`${globalStyles["nav-item"]} ${classes["nav-item"]}`}
                    >
                      <button
                        className={`${globalStyles["nav-link"]} ${
                          classes["nav-link"]
                        } ${isLogin && globalStyles.active} ${
                          isLogin && classes.active
                        }`}
                        onClick={toggleLoginSignup}
                        disabled={isLogin}
                      >
                        Log In
                      </button>
                    </li>
                    <li
                      className={`${globalStyles["nav-item"]} ${classes["nav-item"]}`}
                    >
                      <button
                        className={`${globalStyles["nav-link"]} ${
                          classes["nav-link"]
                        } ${!isLogin && globalStyles.active} ${
                          !isLogin && classes.active
                        }`}
                        onClick={toggleLoginSignup}
                        disabled={!isLogin}
                      >
                        Sign Up
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className={globalStyles["card-body"]}>
              <div
                className={`${globalStyles["tab-content"]} ${classes["tab-content"]}`}
              >
                <div
                  className={`${globalStyles["tab-pane"]} ${
                    globalStyles["fade"]
                  } ${globalStyles["show"]} ${classes["show"]} ${
                    isLogin && globalStyles.active
                  } ${isLogin && classes.active}`}
                  id="log_in"
                  role="tabpanel"
                  aria-labelledby="first-tab"
                >
                  <div className={classes["global-container"]}>
                    <div
                      className={`${globalStyles.card} ${classes["login-form"]}`}
                    >
                      <div className={globalStyles["card-body"]}>
                        <div className={globalStyles["card-text"]}>
                          {isLogin && (
                            <LoginForm
                              isLogin={isLogin}
                              toggleLoginSignup={toggleLoginSignup}
                            ></LoginForm>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${globalStyles["tab-pane"]} ${
                    globalStyles["fade"]
                  } ${globalStyles["show"]} ${classes["show"]} ${
                    !isLogin && globalStyles.active
                  } ${!isLogin && classes.active}`}
                  id="sign_up"
                  role="tabpanel"
                  aria-labelledby="second-tab"
                >
                  <div className={classes["global-container"]}>
                    <div
                      className={`${globalStyles.card} ${classes["login-form"]}`}
                    >
                      <div className={globalStyles["card-body"]}>
                        <div className={globalStyles["card-text"]}>
                          {!isLogin && (
                            <LoginForm
                              isLogin={isLogin}
                              toggleLoginSignup={toggleLoginSignup}
                            ></LoginForm>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
